<template>
  <div class="pt-12 bg-F2F2F6 p-0-16">
    <div class="font-28 c-171A1D-40 lh-36">人脸录入</div>
    <entryInfo-card
      :centerInfo="faceInfo"
      title="人脸录入管理"
      type="person"
      @click="handlerClick"
    ></entryInfo-card>
    <div class="font-28 c-171A1D-40 lh-36 mt-12">身份信息录入</div>
    <entryInfo-card
      class="mb-12"
      :centerInfo="studentInfo"
      @click="handlerDetail"
      title="身份信息管理"
    ></entryInfo-card>
  </div>
</template>

<script>
import API from '@/api'
import entryInfoCard from '@/components/entryInfoCard.vue'
import mixin from '@/mixin'
import { LEAVE_ROLE } from '@/utils/constUtils'
import { mcOpenLink } from '@/utils/mcSdkUtils'
import { enterFace } from '@/utils/comUtils'

export default {
  name: 'PageGuardianIndex',
  mixins: [mixin],
  components: {
    entryInfoCard
  },
  data() {
    return {
      faceSourceType: 0, // 1:ding人脸库，2：魔方人脸库 3: 拱墅人脸库
      faceInfo: [
        {
          title: '总人数：',
          num: '0'
        },
        {
          title: '未录入：',
          num: '0'
        }
      ],
      studentInfo: [
        {
          title: '总人数：',
          num: '0'
        },
        {
          title: '待完善：',
          num: '0'
        }
      ]
    }
  },
  created() {
    // this.getUserFaceStatistic()
    // this.getUserFamilyList()
    this.getUserFaceStatistic()
    this.getUserFamilyList()
    this.getApi('getFaceSource', {}).then(res => {
      this.faceSourceType = +res
    })
  },
  activated() {
    this.getUserFaceStatistic()
    this.getUserFamilyList()
    this.getApi('getFaceSource', {}).then(res => {
      this.faceSourceType = +res
    })
  },
  methods: {
    getUserFaceStatistic() {
      return new Promise((resolve, reject) => {
        API.getUserFaceStatistic({
          campusId: this.campusId,
          operUserRoleTypes: LEAVE_ROLE.guardian,
          memberId: this.$store.getters.orgUserId
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              return false
            }
            this.faceInfo[0].num = res.totalCount
            this.faceInfo[1].num = res.totalCount - res.alreadyCount
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    getUserFamilyList() {
      return new Promise((resolve, reject) => {
        API.getUserFamilyList({
          campusId: this.campusId,
          operUserRoleTypes: LEAVE_ROLE.guardian,
          memberId: this.$store.getters.orgUserId
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              return false
            }
            this.studentInfo[0].num = res.totalCount
            this.studentInfo[1].num = res.totalCount - res.alreadyCount
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    handlerClick() {
      mcOpenLink({
        url: enterFace(this.faceSourceType, this.corpId, 1)
      })
    },
    handlerDetail() {
      this.$router.push({
        path: '/entryInformation/guardian/detail'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-F2F2F6 {
  background: #f2f2f6;
}
</style>
